import { render } from "./CampaignAdd.vue?vue&type=template&id=c5f556c8&scoped=true"
import script from "./CampaignAdd.vue?vue&type=script&lang=js"
export * from "./CampaignAdd.vue?vue&type=script&lang=js"

import "./CampaignAdd.vue?vue&type=style&index=0&id=c5f556c8&scoped=true&lang=scss"
import "../assets/css/campaignAdd.css?vue&type=style&index=1&id=c5f556c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f556c8"]])

export default __exports__